import React from 'react'

export interface RowProps {
  children: React.ReactNode;
}

export function InputBlockRow ({ children }: RowProps) {
  return (
    <div
      className='group/input-group-row grid grid-cols-[repeat(auto-fit,minmax(0,1fr))] items-stretch h-14'
    >
      {children}
    </div>
  )
}
